const trustTentants = [
  'c94b990c-1eab-40ea-bbdf-684635bc5af2', // <- sky
  'fb3d6bd4-7892-436a-b9b1-9f284389995e', // <- conta de teste (dev)
  'ed7d5fa4-776d-4240-b1d2-8219ed9b455d', // <- conta de teste (beta)
];

export default trustTentants;
